import React from "react";
import styled from "styled-components";
import moment from "moment";
import {
  CPanel,
  CFontIcon,
  H4,
  Text,
  Box,
  Flex
} from "@appcues/component-library";

const BillingHistory = props => {
  const { billingHistory } = props;

  let invoiceRows;
  const invoices = billingHistory.data;

  invoiceRows = invoices
    .filter(
      invoice =>
        !!invoice &&
        (invoice.status !== "draft" || invoice.next_payment_attempt) &&
        invoice.total !== 0
    )
    .map(invoice => {
      const plan = (
        invoice.lines.data.find(line => line.id.startsWith("sub_")) || {}
      ).plan;
      const paidText = invoice.paid
        ? "Successful"
        : invoice.next_payment_attempt || invoice.status === "open"
        ? "Pending"
        : "Failed";
      const paidColor =
        paidText === "Successful"
          ? "$green"
          : paidText === "Pending"
          ? "$gray"
          : "$red-dark";
      const date = moment(invoice.date * 1000).format("MMM D, YYYY");

      return (
        <InvoiceRow key={invoice.id}>
          <Text width="15%">{date}</Text>
          <Text flexGrow={1}>{plan ? plan.name : "Balance Adjustment"}</Text>
          <InvoiceAmount width="15%">
            {(invoice.total < 0 ? "-" : "") +
              "$" +
              (Math.abs(invoice.total) / 100).toFixed(2)}
          </InvoiceAmount>
          <Text color={paidColor} width="15%" fontWeight={700}>
            {paidText}
          </Text>
          <Box is="a" href={invoice.hosted_invoice_url} width="15%">
            <InvoiceIcon
              className="far fa-eye"
              altText="Click to download invoice"
              display={invoice.status === "draft" ? "none" : "block"}
            />
          </Box>
        </InvoiceRow>
      );
    });

  return (
    <CPanel>
      <CPanel.Header>
        <H4 type="secondary">Billing History</H4>
      </CPanel.Header>
      <Box marginTop={16}>
        <Flex
          justifyContent="space-between"
          paddingBottom="0.25rem"
          alignItems="baseline"
          color="$gray-5"
        >
          <Text width="15%">Date</Text>
          <Text flexGrow={1}>Description</Text>
          <InvoiceAmount width="15%">Amount</InvoiceAmount>
          <Text width="15%">Status</Text>
          <Text width="15%">Invoice</Text>
        </Flex>
        {invoiceRows}
      </Box>
    </CPanel>
  );
};

export default BillingHistory;

const InvoiceRow = styled.div`
  display: flex;
  justify-content: space-between;
  border-top: 1px solid ${props => props.theme["$gray-3"]};
  padding: 0.5rem 0;
  align-items: baseline;
`;

const InvoiceIcon = styled(CFontIcon)`
  color: ${props => props.theme["$gray-5"]};
  cursor: pointer;
  padding-left: 16px;

  &:hover {
    color: ${props => props.theme["$gray-6"]};
  }
`;

const InvoiceAmount = styled.text`
  align: right;
  padding-right: 40px;
  color: ${props => props.theme["$gray-7"]};
  font-variant-numeric: tabular-nums;
`;
